module.exports = __webpack_public_path__ + "static/media/vimeo-video.a8c02ce4.png";